import { motion } from 'framer-motion'

import { OfferWrapper } from './OfferWrapper'

export const animationVariants = {
  visible: { height: '100%', originY: 0, opacity: 1, scaleY: 1 },
  hidden: { height: '0', originY: 0, opacity: 0, scaleY: 0 },
}

export const AnimatedOfferWrapper = motion(OfferWrapper)
